// Constitution Table D (D05), "Farrowing survival": % of piglets born that
// survive. Only a problem gets color, always with its word; a good value stays
// in plain ink.
export type ValueTone = {ink: string; word: string};

export function farrowingSurvivalTone(survival: number): ValueTone | null {
  if (!Number.isFinite(survival)) return null;
  if (survival < 65) return {ink: 'var(--danger-ink)', word: 'Low Survival'};
  if (survival < 80) return {ink: 'var(--warn-ink)', word: 'Low Survival'};
  return null;
}
